import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onepage-navbar',
  templateUrl: './onepage-navbar.component.html',
  styleUrls: ['./onepage-navbar.component.scss']
})
export class OnepageNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
